@if (form) {
	<form [formGroup]="form">
		<ng-container formGroupName="booker">
			<p class="u-title-sub u-m-bottom--xs">{{ 'BOOKING.DETAILS.TITLE' | translate }}</p>
			<p [innerHTML]="'BOOKING.DETAILS.DESCRIPTION' | translate" class="u-m-bottom--sm"></p>

			<div class="u-row">
				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FIRSTNAME' | translate" name="firstName" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
				</tvcore-input>

				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.LASTNAME' | translate" name="lastName" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
				</tvcore-input>
			</div>

			<div class="u-row">
				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
				</tvcore-input>

				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.PHONE' | translate" name="phone" type="tel" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="format">{{ 'FORM.ERROR.PHONE_INVALID' | translate }}</tvcore-input-error>
				</tvcore-input>
			</div>

			<div class="u-row">
				<tvcore-datepicker class="u-col-sm--12 u-col--6" [label]="'BOOKING.OH_DETAILS.BIRTH_DATE' | translate" name="birthDate" icon="date" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
				</tvcore-datepicker>

				<tvcore-dropdown class="u-col-sm--12 u-col--6" [label]="'BOOKING.OH_DETAILS.GENDER' | translate" name="gender" [options]="GENDERS" [showErrors]="showErrors">
					<ng-template #optionTemplate let-option>{{ 'BOOKING.OH_DETAILS.GENDER_' + option | translate }}</ng-template>
				</tvcore-dropdown>
			</div>
		</ng-container>

		<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'BOOKING.OH_DETAILS.FAMILY_TITLE' | translate }}</p>
		<p class="u-m-bottom--sm" [innerHTML]="'BOOKING.OH_DETAILS.FAMILY_DESCRIPTION' | translate"></p>

		<div formArrayName="family">
			@for (group of family.controls; track group) {
				<div class="c-family u-m-bottom--sm" [formGroupName]="$index">
					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--4" [label]="'FORM.FIELD.FULL_NAME' | translate" name="fullName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-datepicker class="u-col-sm--12 u-col--4" [label]="'BOOKING.OH_DETAILS.BIRTH_DATE' | translate" name="birthDate" icon="date" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-datepicker>

						<tvcore-dropdown class="u-col-sm--12 u-col--4" [label]="'BOOKING.OH_DETAILS.GENDER' | translate" name="gender" [options]="GENDERS" [showErrors]="showErrors">
							<ng-template #optionTemplate let-option>{{ 'BOOKING.OH_DETAILS.GENDER_' + option | translate }}</ng-template>
						</tvcore-dropdown>
					</div>

					<button class="c-btn-link c-btn--with-icon" (click)="removeFamilyMember($index)" type="button">
						<tvcore-icon name="trash"></tvcore-icon>
						{{ 'BOOKING.OH_DETAILS.REMOVE_MEMBER_BUTTON' | translate }}
					</button>
				</div>
			}

			<button class="c-btn-link c-btn--with-icon" (click)="addFamilyMember()" type="button">
				<tvcore-icon name="plus"></tvcore-icon>
				{{ 'BOOKING.OH_DETAILS.ADD_MEMBER_BUTTON' | translate }}
			</button>
		</div>

		<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'BOOKING.OH_DETAILS.GUIDE_TITLE' | translate }}</p>

		<div formArrayName="guide">
			@for (group of guide.controls; track group) {
				<div class="c-guide u-m-bottom--sm" [formGroupName]="$index">
					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FIRSTNAME' | translate" name="firstName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.LASTNAME' | translate" name="lastName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.PHONE' | translate" name="phone" type="tel" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="format">{{ 'FORM.ERROR.PHONE_INVALID' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<button class="c-btn-link c-btn--with-icon" (click)="removeGuide($index)" type="button">
						<tvcore-icon name="trash"></tvcore-icon>
						{{ 'BOOKING.OH_DETAILS.REMOVE_GUIDE_BUTTON' | translate }}
					</button>
				</div>
			}

			<button class="c-btn-link c-btn--with-icon" (click)="addGuide()" type="button">
				<tvcore-icon name="plus"></tvcore-icon>
				{{ 'BOOKING.OH_DETAILS.ADD_GUIDE_BUTTON' | translate }}
			</button>
		</div>
	</form>
}
